import { useEffect, useRef, useState } from "react";
interface LazyVideoProps {
  src: string;
  poster: string;
  className?: string;
  controls?: boolean;
  playsInline?: boolean;
}
const LazyVideo = ({
  src,
  poster,
  className = "",
  controls = true,
  playsInline = true
}: LazyVideoProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isInView, setIsInView] = useState(false);
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        setIsInView(true);
        observer.disconnect();
      }
    }, {
      rootMargin: "200px"
    });
    observer.observe(video);
    return () => observer.disconnect();
  }, []);
  return (
    <video
      ref={videoRef}
      className={className}
      poster={poster}
      controls={controls}
      playsInline={playsInline}
      preload="none"
    >
      {isInView && <source src={src} type="video/mp4" />}
    </video>
  );
};
export default LazyVideo;